import React, { useEffect, useState } from "react";
import { Trophy, Clock, Crown } from "lucide-react";
import { api } from "../lib/api";
import StorefrontHeader from "../components/StorefrontHeader";
import { RoundCard } from "./Storefront";
import useEmbedResize from "../hooks/useEmbedResize";

/**
 * Format hub: image-based head-to-head competitions.
 */
export default function StorefrontCompetitions() {
  useEmbedResize();
  const [rounds, setRounds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.publicListRounds().then(setRounds).catch(() => setRounds([])).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAFAF7]" data-testid="storefront-competitions-page">
      <StorefrontHeader active="competitions" />

      <main className="max-w-6xl mx-auto px-6 md:px-10 py-10 md:py-16">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-widest text-[#d0473e] font-semibold">
            <Trophy size={12} /> Single-product
          </div>
          <h1 className="text-3xl sm:text-5xl font-semibold tracking-tight mt-3 leading-tight text-[#111]">
            The Solo.
          </h1>
          <p className="text-base sm:text-lg text-[#6D7175] mt-4 leading-relaxed">
            Single products go head-to-head — one product per entry. The top voted at the deadline becomes available to pre-order.
            One vote per product, per email.
          </p>
          <div className="mt-6 flex items-center gap-4 text-xs text-[#6D7175]">
            <span className="inline-flex items-center gap-1.5"><Crown size={12} className="text-[#d0473e]" /> Top N win pre-order</span>
            <span className="inline-flex items-center gap-1.5"><Clock size={12} className="text-[#d0473e]" /> Deadline-based</span>
          </div>
        </div>

        <section className="mt-12" data-testid="competitions-list">
          {loading ? (
            <div className="lp-card p-12 text-center text-sm text-gray-500">Loading competitions…</div>
          ) : rounds.length === 0 ? (
            <div className="lp-card p-16 text-center" data-testid="competitions-empty">
              <div className="w-14 h-14 rounded-2xl bg-amber-50 border border-amber-100 flex items-center justify-center mx-auto mb-4">
                <Trophy size={22} className="text-amber-600" />
              </div>
              <h3 className="text-lg font-medium tracking-tight">No live Solo rounds right now</h3>
              <p className="text-sm text-gray-500 mt-2 max-w-sm mx-auto">
                Check back soon — we run new single-product face-offs regularly.
              </p>
            </div>
          ) : (
            <>
              <div className="flex items-baseline justify-between mb-4">
                <h2 className="text-base font-medium tracking-tight">Live Solo rounds</h2>
                <span className="text-xs text-gray-500">{rounds.length} active</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {rounds.map((r) => (
                  <RoundCard key={r.id} round={r} />
                ))}
              </div>
            </>
          )}
        </section>
      </main>
    </div>
  );
}
